export const sectionItemClasses = {
  fullWidth: 'section-item-full-width',
  fixedWidth: 'section-item-fixed-width',
}

export const FIXED_WIDTH_ITEM_MAX_WIDTH = '--fixed-width-item-max-width'
